import React, { useState } from 'react'
import { getMediaUrl } from '../../utils/mediaUtils'
import ConfirmDialog from '../ConfirmDialog'

const MediaActions = ({ selectedMedia, isOwner, loading, onDeleteMedia }) => {
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)

  const handleDeleteClick = () => {
    setShowDeleteConfirm(true)
  }

  const handleConfirmDelete = () => {
    setShowDeleteConfirm(false)
    onDeleteMedia(selectedMedia._id)
  }

  const handleCancelDelete = () => {
    setShowDeleteConfirm(false)
  }

  return (
    <>
      <div className="space-y-3 pt-4 border-t border-white/10">
        <button
          onClick={() => window.open(getMediaUrl(selectedMedia), '_blank')}
          className="w-full bg-purple-600 hover:bg-purple-700 text-white font-medium py-2 px-4 rounded-lg transition-colors"
        >
          View Full Size
        </button>
        {isOwner && (
          <button
            onClick={handleDeleteClick}
            disabled={loading}
            className="w-full bg-red-600 hover:bg-red-700 disabled:bg-gray-600 text-white font-medium py-2 px-4 rounded-lg transition-colors"
          >
            {loading ? 'Deleting...' : 'Delete Media'}
          </button>
        )}
      </div>

      <ConfirmDialog
        isOpen={showDeleteConfirm}
        title="Delete Media"
        message="Are you sure you want to delete this media? This action cannot be undone."
        onConfirm={handleConfirmDelete}
        onCancel={handleCancelDelete}
        confirmText="Delete"
        cancelText="Cancel"
        confirmButtonClass="bg-red-600 hover:bg-red-700"
      />
    </>
  )
}

export default MediaActions